<template>
  <button
    @click="printAction"
    :disabled="disabled"
    title="Print the current selection to PDF"
  >
    <span> Print <font-awesome-icon icon="file-pdf" /> </span>
  </button>
</template>
<script>
export default {
  name: "PrintAction",
  props: {
    cellFormat: Function,
    disabled: Boolean,
    entityNamePlural: String,
    selectOrFilter: Object,
    visibleOrderedColumns: Array
  },
  methods: {
    printAction() {
      const rowConverter = data => {
        const excluded = ["action", "table"];
        let rows = [
          this.visibleOrderedColumns
            .filter(column => !excluded.includes(column.type))
            .map(column => column.label)
        ];
        for (const row of data) {
          rows.push(
            this.visibleOrderedColumns
              .filter(column => !excluded.includes(column.type))
              .map(column => this.cellFormat(column, row))
          );
        }
        return {
          now: this.$options.filters.prettyDateTime(new Date()),
          title: this.$options.filters.capitalize(this.entityNamePlural),
          subtitle: `${data.length} ${
            data.length === 1 ? "record" : "records"
          }`,
          rows: rows
        };
      };
      this.$emit("printAction", this.selectOrFilter, rowConverter);
    }
  }
};
</script>
